import Box from "@mui/material/Box";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Typography from "components/common/Typography";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { deleteMyList, setShowDeleteDialog } from "./sme.slice";

interface Props {
  data: any;
  open: boolean;
}

const DeleteDialog = (props: Props) => {
  const { data, open } = props;
  const dispatch = useAppDispatch();
  let [searchParams, setSearchParams] = useSearchParams();
  let selectedTabId = searchParams.get("tab");
  const { myLists } = useAppSelector((state) => state.sme);
  const { records } = myLists;

  const handleClose = () => {
    dispatch(setShowDeleteDialog({ show: false, id: null }));
  };

  const handleDelete = async () => {
    /* @ts-ignore */
    const index = records.findIndex((el) => el.id === data?.id);

    dispatch(deleteMyList(data?.id)).then((response: any) => {
      if (response?.payload?.errors?.length) {
        return;
      }
      if (records.length) {
        if (index > 0) {
          /* @ts-ignore */
          setSearchParams({ id: records[index - 1]?.id, tab: selectedTabId ?? "inncodes" });
        } else {
          /* @ts-ignore */
          setSearchParams({ id: records[index + 1]?.id, tab: selectedTabId ?? "inncodes" });
        }
      }
    });
  };

  return (
    <DialogFormation
      openDialog={open}
      handleClose={handleClose}
      title="Delete List"
      actionConfig={
        <div className="modal-config-wrapper">
          <Button label="Cancel" variant="secondary" onClick={handleClose} />
          <Button
            variant="alert"
            label="Delete"
            onClick={handleDelete}
            sx={{
              backgroundColor: tokens.Icon.Feeback.Alert,
              color: tokens.Text.General.Inverse,
              "&:hover": { color: tokens.Icon.Feeback.Alert }
            }}
          />
        </div>
      }
    >
      <Typography variant="body1" color={tokens.Text.General.PrimaryHeadline} sx={{ textAlign: "center" }}>
        Deleting the
        <Box component="span" sx={{ color: tokens.Text.General.PrimaryHeadline, fontWeight: 600 }}>
          {" "}
          {data?.name}
        </Box>{" "}
        list removes all user info. This action can't be undone. Do you wish to proceed?
      </Typography>
    </DialogFormation>
  );
};

export default DeleteDialog;
